// react
import { useEffect, useState } from "react";

// next
import { useRouter } from "next/router";

// redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getMessageCount } from "~/redux/actions/message";
import { getJobsSummary } from "~/redux/actions/app";
import { showAppModal, showAppMessage } from "~/redux/actions/app";
import { signout } from "~/redux/actions/user";

// views
import Link from "next/link";
import { Menu, Avatar, Badge, Row, Col, Input, Tooltip, message } from "antd";
import AppSearch from "~/components/app/AppSearch";

// lodash
import _ from "lodash";

// utils
import { avatarUrl, truncate } from "~/utils/app";
import { hasContactInfo } from "~/utils/user";
import { isWechatBrowser } from "~/utils/wechat";
import { hasAnyRole } from "../../utils/user";
import UserBadge from "../user/UserBadge";
import settings from "../../settings";
import { isMobile } from "react-device-detect";
import { getUserBadge } from "../../utils/ui";

const { Search } = Input;

const AppMenuRight = (props) => {
  // router
  const router = useRouter();

  // props
  const { user, token, messageCount } = props;
  const [items, setItems] = useState();

  // handles
  const handleSignin = () => {
    if (isWechatBrowser()) {
      props.showAppModal("WechatSigninModal");
    } else {
      props.showAppModal("PhoneSigninModal");
    }
  };
  const handleSignup = () => {
    props.showAppModal("PhoneSignupModal");
  };
  const handleInit = () => {
    token && props.getMessageCount(token);
    token && props.getJobsSummary(token);
  };
  const handleSearch = (key) => {
    const keyword = encodeURIComponent(_.trim(key));
    keyword
      ? router.push("/search?keyword=" + keyword)
      : props.showAppMessage("请输您要搜索的关键字", "info");
  };

  // events
  useEffect(() => handleInit(), []);

  const isAdmin = hasAnyRole(props.user, ["admin"]);
  const isHr = hasAnyRole(props.user, ["hr"]);
  let avatarSize = props.mode === "horizontal" ? 45 : 20;

  const hasUnreadApplicationMsg = messageCount.jobApplicationMsgCount > 0;
  const hasUnreadEmployerMsg = messageCount.employerMsgCount > 0;
  const hasPendingApplications =
    props.jobsSummary.pending_applications_count > 0;

  const buildBaseItems = () => [
    {
      label: (
        <a
          className="menu-link-item"
          href="/profile/info"
        >
          <Row
            type="flex"
            align="middle"
          >
            <Col
              span={18}
              className="text"
            >
              个人主页
            </Col>
            <Col span={6}>
              <div className="flex-center">
                <Badge dot={!hasContactInfo(user)}></Badge>
              </div>
            </Col>
          </Row>
        </a>
      ),
      key: "个人主页",
    },
    {
      label: (
        <a
          className="menu-link-item"
          href="/messages"
        >
          <Row
            type="flex"
            align="middle"
          >
            <Col
              span={18}
              className="text-"
            >
              我的消息
            </Col>
            <Col span={6}>
              <div className="flex-center">
                <Badge
                  count={messageCount.total}
                  style={{
                    fontSize: "10px",
                    height: "14px",
                    lineHeight: "14px",
                  }}
                />
              </div>
            </Col>
          </Row>
        </a>
      ),
      key: "我的消息",
    },
    {
      label: (
        <Link
          legacyBehavior
          href={`${settings.talentUrl}/me/profile`}
        >
          <a className="text-md menu-link-item">我的简历</a>
        </Link>
      ),
      key: "我的简历",
    },
    {
      label: (
        <a
          className="menu-link-item"
          href="/applications/jobs_channel"
        >
          <Row
            type="flex"
            align="middle"
          >
            <Col
              span={18}
              className="text"
            >
              我的申请
            </Col>
            <Col span={6}>
              <div className="flex-center">
                <Badge dot={hasUnreadApplicationMsg}></Badge>
              </div>
            </Col>
          </Row>
        </a>
      ),
      key: "我的申请",
    },
    {
      label: (
        <a
          className="menu-link-item"
          href="/recruitments?status=published"
        >
          <Row
            type="flex"
            align="middle"
          >
            <Col
              span={18}
              className="text"
            >
              招聘管理
            </Col>
            <Col span={6}>
              <div className="flex-center">
                <Badge
                  dot={hasPendingApplications || hasUnreadEmployerMsg}
                ></Badge>
              </div>
            </Col>
          </Row>
        </a>
      ),
      key: "招聘管理",
    },
  ];

  // const searchItems = [
  //   {
  //     label: (
  //       <div className="app-menu-search">
  //         <Search
  //           placeholder="请输入关键字"
  //           onSearch={(value) => handleSearch(value)}
  //           style={{ width: 180 }}
  //           enterButton
  //         />
  //       </div>
  //     ),
  //     key: "关键字查询",
  //   },
  // ];
  const searchItems = [
    {
      label: <AppSearch></AppSearch>,
      key: "关键字查询",
    },
  ];

  const loginItems = [
    { label: <span onClick={handleSignin}>登录</span>, key: "登录" },
    { label: <span onClick={handleSignup}>注册</span>, key: "注册" },
  ];

  const signoutItem = {
    label: <a onClick={() => props.signout()}>退出</a>,
    key: "退出",
  };

  const reportItem = {
    label: (
      <Link
        legacyBehavior
        href={`/admin/reports`}
      >
        <a className="menu-link-item">后台管理-管理员</a>
      </Link>
    ),
    key: "后台管理-管理员",
  };

  const talentHrItem = {
    label: (
      <Link
        legacyBehavior
        href={`${settings.talentUrl}/hr`}
      >
        <a className="menu-link-item">远程人才库-HR</a>
      </Link>
    ),
    key: "远程人才库-HR",
  };

  const talentAdminItem = {
    label: (
      <Link
        legacyBehavior
        href={`${settings.talentUrl}/admin`}
      >
        <a className="menu-link-item">远程人才库-管理员</a>
      </Link>
    ),
    key: "远程人才库-管理员",
  };

  const buildItems = (items) => buildBaseItems().concat(items);

  useEffect(() => {
    if (props.user) {
      const headerItem = {
        label: (
          <span style={{ position: "relative" }}>
            <Badge
              dot={
                messageCount.total > 0 ||
                !hasContactInfo(user) ||
                hasPendingApplications
              }
            >
              <Avatar
                src={avatarUrl(user, 48)}
                size={avatarSize}
                style={getUserBadge({ user, avatarSize }).avatarBorderStyle}
                shape="circle"
              />
            </Badge>
            {avatarSize > 20 && (
              <UserBadge
                user={user}
                position="AppMenuRight"
                avatarSize={avatarSize}
              />
            )}
            <span
              className="ml-5"
              title={user.nickname}
            >
              {truncate(user.nickname, 12)}
            </span>
          </span>
        ),
        children: [],
        key: "headerItem",
      };
      if (isMobile || (!isHr && !isAdmin)) {
        headerItem.children = buildItems([signoutItem]);
      } else {
        if (isHr && isAdmin) {
          headerItem.children = buildItems([
            talentHrItem,
            talentAdminItem,
            reportItem,
            signoutItem,
          ]);
        } else if (isAdmin && !isHr) {
          headerItem.children = buildItems([
            talentAdminItem,
            reportItem,
            signoutItem,
          ]);
        } else if (isHr && !isAdmin) {
          headerItem.children = buildItems([talentHrItem, signoutItem]);
        }
      }
      setItems(isMobile ? [headerItem] : searchItems.concat(headerItem));
    } else {
      setItems(isMobile ? loginItems : searchItems.concat(loginItems));
    }
  }, [props.user, props.messageCount]);

  return (
    <Menu
      items={items}
      mode={props.mode}
      selectable={false}
      className="app-menu-right"
      disabledOverflow={true}
    />
  );
};

const mapStateToProps = (state) => ({
  token: state.user.token,
  user: state.user.user,
  messageCount: state.message.messageCount,
  jobsSummary: state.app.jobsSummary,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showAppModal,
      getMessageCount,
      getJobsSummary,
      signout,
      showAppMessage,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AppMenuRight);
